import React from "react";
import { Box, Container } from "@mui/material";
import { motion } from "framer-motion";

import { translation } from "../../assets/translation";
import { commonPaddingLeft, commonPaddingRight, language } from "../../assets/function";
import CustomText from "../../customComponents/customText";
import { Colors } from "../../assets/colors";
import MainHeader from "../../customComponents/MainHeader.jsx";
let staticText = translation[language];

function GetAiReady() {
  return (
    <Box sx={styles.appBarStyle}>
      <Container maxWidth="xl" sx={styles.containerStyle}>
        {/* Logo for desktop */}
        <Box sx={{ flexGrow: 1, justifyContent: "center", display: "flex" }}>
          <Box>
            <motion.div
              initial={{ opacity: 0, y: 100 }} // Start from bottom
              animate={{ opacity: 1, y: 0 }} // Move to original position
              transition={{ duration: 0.8 }} // Animation duration
            >
              <MainHeader heading={staticText.getAiReadyText} 
                headerStyle={{
                  fontSize: {
                    xs: 28,    // 0-600px
                    sm: 40,    // 600-900px
                    md: 48,    // 900-1200px
                    lg: 56,    // 1200-1536px
                    xl: 64,    // >1536px
                  }
                }}
              />
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 100 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.3 }} // Delayed start for staggered effect
            >
              <CustomText
                desc={staticText.getWhat}
                fontFamily="Inter"
                colorvalue={Colors.getAiReadyTxt}
                style={styles.getAiReadyTxt}
                h3
                fontWeight={400}
              />
            </motion.div>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}

export default GetAiReady;

const styles = {
  getAiReadyTxt: {
    textAlign: {
      xs: "center",    // 0-600px
      sm: "center",    // 600-900px
      md: "center",    // 900-1200px
      lg: "center",    // 1200-1536px
      xl: "center",    // >1536px
    },
    marginTop:{xs:1.3,sm:0},
    fontSize: {
      xs: 18,    // 0-600px
      sm: 20,  // 600-900px
      md: 24,    // 900-1200px
      lg: 28,  // 1200-1536px
      xl: 32,    // >1536px
    },
    lineHeight: {
      xs: 1.5,    // 0-600px
      sm: 2.5,  // 600-900px
      md: 3,    // 900-1200px
      lg: 3.5,  // 1200-1536px
      xl: 4,    // >1536px
    },
    paddingBottom: {
      xs: 3,    // 0-600px
      sm: 2.5,  // 600-900px
      md: 3,    // 900-1200px
      lg: 3.5,  // 1200-1536px
      xl: 4,    // >1536px
    },
    fontStyle: "initial",
  },
 

  appBarStyle: {
    overflowX: "hidden",
    boxSizing: "border-box",
    backgroundColor: Colors.themeColor,
    paddingLeft: commonPaddingLeft,
    paddingRight: commonPaddingRight,
    
  },

  containerStyle: {
    display: "flex",
    alignItems: "center",
    justifyItems: "center",
    justifyContent: "center",
    paddingTop: {
      xs: 4,    // 0-600px
      sm: 6,    // 600-900px
      md: 8,    // 900-1200px
      lg: 10,   // 1200-1536px
      xl: 12,   // >1536px
    },
    paddingBottom: {
      xs: 2,
      sm: 2,
      md: 3,
      lg: 3,
      xl: 4,
    },
  },
};
